<template>
	<div>
		<!-- Institute select and and new button  -->
		<div class="d-flex justify-content-between align-items-center">
			<div class="px-0 mb-3" v-if="checkUser">
				<v-select
					data-testId="institute-select"
					auto-select-first
					v-bind:items="institutes"
					v-model="currentIns"
					v-on:change="changeInstitute"
					item-text="name"
					item-value="id"
					:label="$t('instituteName')"
					color="green"
					item-color="green"
				>
				</v-select>
			</div>
			<v-spacer></v-spacer>
			<v-btn
				data-testId="add-halaqa-btn"
				color="success"
				class="mx-5"
				@click="addHalaqaDialog = true"
			>
				<v-icon color="#fff" class="m-0 me-2">mdi-plus</v-icon>
				<span>{{ $t("addHalaqa") }}</span>
			</v-btn>
		</div>

		<!-- Search inputs -->
		<div class="search">
			<div class="search-inputs">
				<v-dialog
					data-testId="from-date-dialog"
					ref="fromDateDialog"
					width="290px"
					v-model="fromDateModal"
					:return-value.sync="search.fromDate"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							data-testId="from-date-input"
							:label="$t('fromDate')"
							prepend-icon="mdi-calendar"
							filled
							v-bind="attrs"
							v-on="on"
							color="green"
							clearable
							clear-icon="mdi-close-circle"
							readonly
							v-model="search.fromDate"
						>
						</v-text-field>
					</template>
					<v-date-picker
						v-model="search.fromDate"
						:min="new Date().toISOString()"
					>
						<v-spacer></v-spacer>
						<v-btn text color="red" @click="fromDateModal = false">
							{{ $t("Cancel") }}
						</v-btn>
						<v-btn
							text
							color="green"
							@click="$refs.fromDateDialog.save(search.fromDate)"
						>
							{{ $t("ok") }}
						</v-btn>
					</v-date-picker>
				</v-dialog>
				<v-dialog
					data-testId="to-date-dialog"
					ref="toDateDialog"
					width="290px"
					v-model="toDateModal"
					:return-value.sync="search.toDate"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							data-testId="to-date-input"
							:label="$t('toDate')"
							prepend-icon="mdi-calendar"
							filled
							v-bind="attrs"
							v-on="on"
							color="green"
							clearable
							clear-icon="mdi-close-circle"
							readonly
							v-model="search.toDate"
						>
						</v-text-field>
					</template>
					<v-date-picker
						v-model="search.toDate"
						:min="new Date().toISOString()"
					>
						<v-spacer></v-spacer>
						<v-btn text color="red" @click="toDateModal = false">
							{{ $t("Cancel") }}
						</v-btn>
						<v-btn
							text
							color="green"
							@click="$refs.toDateDialog.save(search.toDate)"
						>
							{{ $t("ok") }}
						</v-btn>
					</v-date-picker>
				</v-dialog>
				<v-text-field
					data-testId="tutor-name-input"
					v-model="search.tutorName"
					:label="$t('tutorName')"
					color="green"
					clearable
					clear-icon="mdi-close-circle"
				></v-text-field>
				<v-text-field
					data-testId="halaqa-type-input"
					v-model="search.halaqaType"
					:label="$t('webinar_Type')"
					color="green"
					clearable
					clear-icon="mdi-close-circle"
				></v-text-field>
			</div>
			<div class="search-btn-group">
				<v-btn
					data-testId="search-btn"
					color="success"
					class="me-4"
					@click="filterWebinars"
				>
					{{ $t("search") }}
				</v-btn>
				<v-btn data-testId="clear-btn" color="error" @click="clearSearch">
					{{ $t("clear") }}
				</v-btn>
			</div>
		</div>

		<!-- Upcoming webinars tabular view -->
		<div class="mt-8">
			<v-data-table
				:headers="webinarHeadersTitles"
				:items="filteredWebinars"
				item-key="id"
				class="elevation-1"
				:items-per-page="10"
				:footer-props="tableFooterOptions"
				:no-data-text="`${$t('noResultsHere')}`"
			>
			</v-data-table>
		</div>

		<!-- Add halaqa dialog  -->
		<v-dialog
			v-model="addHalaqaDialog"
			transition="dialog-bottom-transition"
			max-width="1100"
			persistent
		>
			<v-card class="p-4">
				<v-card-title
					><span class="text-h5 p-3">
						{{ $t("addHalaqa") }}
					</span>
					<v-spacer></v-spacer>
					<v-btn
						data-testId="close-halaqa-dialog"
						class="mx-2"
						small
						color="success"
						@click="addHalaqaDialog = false"
					>
						<v-icon dark>
							mdi-window-close
						</v-icon>
					</v-btn></v-card-title
				>
				<v-card-text>
					<form class="row">
						<div class="col-md-6 px-4">
							<v-text-field
								data-testId="halaqa-name-input"
								v-model="addHalaqaForm.title"
								:label="$t('webinarName')"
								type="text"
								filled
								color="green"
								class="mb-4"
								clear-icon="mdi-close-circle"
								clearable
							></v-text-field>
						</div>
						<div class="col-md-6 px-4">
							<v-autocomplete
								data-testId="tutor-name-input"
								:items="tutors"
								v-model="addHalaqaForm.tutor"
								item-text="full_name"
								item-value="id"
								filled
								:menu-props="{ maxHeight: '400' }"
								:label="$t('tutorName')"
								color="green"
								clear-icon="mdi-close-circle"
								clearable
								item-color="green"
							></v-autocomplete>
						</div>
						<div class="col-md-6 px-4">
							<v-select
								data-testId="halaqa-type-input"
								:items="webinarType"
								v-model="addHalaqaForm.webinarType"
								item-text="name"
								item-value="name"
								:label="$t('webinar_Type')"
								color="green"
								item-color="green"
							>
							</v-select>
						</div>
						<div class="col-md-6 px-4">
							<v-text-field
								data-testId="minutes-input"
								v-model="addHalaqaForm.NumberOfMinutes"
								:label="$t('classGroups.groupClassDialog.noOfMinutes')"
								type="number"
								filled
								color="green"
								class="mb-4"
								clear-icon="mdi-close-circle"
								clearable
							></v-text-field>
						</div>
						<div class="col-12">
							<v-textarea
								data-testId="halaqa-description"
								filled
								v-model="addHalaqaForm.description"
								class="mb-5 px-4"
								rows="3"
								color="green"
								auto-grow
								:label="$t('quiz.description')"
								clearable
								clear-icon="mdi-close-circle"
							></v-textarea>
						</div>
						<div class="col-md-6 px-4">
							<v-dialog
								ref="startDateDialog"
								width="290px"
								v-model="startDateModal"
								:return-value.sync="addHalaqaForm.startDate"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										data-testId="start-date-input"
										:label="$t('tables.startDate')"
										prepend-icon="mdi-calendar"
										filled
										v-bind="attrs"
										v-on="on"
										color="green"
										clearable
										clear-icon="mdi-close-circle"
										readonly
										v-model="addHalaqaForm.startDate"
									>
									</v-text-field>
								</template>
								<v-date-picker
									v-model="addHalaqaForm.startDate"
									:min="new Date().toISOString()"
								>
									<v-spacer></v-spacer>
									<v-btn text color="red" @click="startDateModal = false">
										{{ $t("Cancel") }}
									</v-btn>
									<v-btn
										text
										color="green"
										@click="$refs.startDateDialog.save(addHalaqaForm.startDate)"
									>
										{{ $t("ok") }}
									</v-btn>
								</v-date-picker>
							</v-dialog>
						</div>
						<div class="col-md-6 px-4">
							<v-dialog
								ref="startTimeDialog"
								width="290px"
								v-model="startTimeModal"
								:return-value.sync="addHalaqaForm.startTime"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										data-testId="start-time-input"
										:label="$t('tables.startTime')"
										prepend-icon="mdi-clock-time-four-outline"
										filled
										v-bind="attrs"
										v-on="on"
										color="green"
										clearable
										clear-icon="mdi-close-circle"
										readonly
										v-model="addHalaqaForm.startTime"
									>
									</v-text-field>
								</template>
								<v-time-picker
									v-model="addHalaqaForm.startTime"
									full-width
									color="green"
									format="ampm"
								>
									<v-spacer></v-spacer>
									<v-btn text color="red" @click="startTimeModal = false">
										{{ $t("Cancel") }}
									</v-btn>
									<v-btn
										text
										color="green"
										@click="$refs.startTimeDialog.save(addHalaqaForm.startTime)"
									>
										{{ $t("ok") }}
									</v-btn>
								</v-time-picker>
							</v-dialog>
						</div>
					</form>
				</v-card-text>
				<v-card-actions class="actions-btn-group pe-6">
					<v-btn
						data-testId="save-halaqa-btn"
						class="action-btn"
						color="green lighten-1"
						@click="addHalaqa"
						>{{ $t("save") }}</v-btn
					>
					<v-btn
						data-testId="cancel-halaqa-btn"
						class="action-btn"
						color="red darken-3"
						@click="cancelHalaqa"
						>{{ $t("Cancel") }}</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";
import moment from "moment";

export default {
	name: "OperatorWebinars",
	mixins: [GlobalMixin],
	data() {
		return {
			tutors: [],
			institutes: [],
			currentIns: null,
			userObj: JSON.parse(localStorage.getItem("vuex")),

			webinars: [],
			filteredWebinars: [],

			tableFooterOptions: {
				"items-per-page-options": [10, 20, 30, 40, 50, 100],
				"show-current-page": true,
				showFirstLastPage: true,
				firstIcon: "mdi-arrow-collapse-left",
				lastIcon: "mdi-arrow-collapse-right",
			},
			noDataText: "There is No Result.",

			search: {
				fromDate: moment(new Date()).format("Y-MM-DD"),
				toDate: moment(new Date())
					.add(1, "M")
					.format("Y-MM-DD"),
				tutorName: "",
				halaqaType: "",
			},

			fromDateModal: false,
			toDateModal: false,

			addHalaqaDialog: false,

			addHalaqaForm: {
				institute: this.currentIns,
				tutor: null,
				startTime: "",
				startDate: "",
				NumberOfMinutes: null,
				webinarType: "",
				webinarLanguage: "",
				title: "",
				description: "",
			},
			webinarType: [{ name: "Tajweed" }, { name: "Quran" }, { name: "Arabic" }],
			startDateModal: false,
			startTimeModal: false,

			webinarLanguage: null,
		};
	},
	mounted() {
		// Get query params for the URL
		this.currentIns = +this.$route.query.ins
			? +this.$route.query.ins
			: this.getInstituteId;
		// Call institutes in case of super admin
		if (this.userObj.auth.user.user.user_type === "operator")
			this.getAllInstitutes();
		this.getWebinars(this.search);
		this.getInstituteTutors();
	},
	methods: {
		/**
		 * Get all Institutes from the API
		 */
		getAllInstitutes() {
			this.axios(`${process.env.VUE_APP_APIEndPoint}institutes/`, this.headers)
				.then(
					res =>
						(this.institutes = res.data.data.sort((a, b) =>
							a?.name.toLowerCase() > b?.name.toLowerCase() ? 1 : -1
						))
				)
				.catch(err => console.error(err));
		},

		/**
		 * Get all Tutors for an institute
		 */
		getInstituteTutors() {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}tutor/operator/listing/`,
					{
						status: "approved",
						institute: this.currentIns,
					},
					this.headers
				)
				.then(
					tutors =>
						(this.tutors = tutors.data.data.tutors.sort((a, b) =>
							a.full_name > b.full_name ? 1 : -1
						))
				)
				.catch(err => console.error(err));
		},

		/**
		 * Change Institute
		 */
		changeInstitute() {
			if (!this.currentIns) this.currentIns = 1;
			history.pushState({}, null, `${this.$route.path}?ins=${this.currentIns}`);
			this.getInstituteTutors();
			this.getWebinars(this.search);
		},

		// Get webinars list
		async getWebinars(searchObj) {
			const body = {
				institute_id: this.currentIns,
				from_date: searchObj.fromDate,
				to_date: searchObj.toDate,
			};
			await this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}p2p/webinars/`,
					body,
					this.headers
				)
				.then(res => {
					this.webinars = res.data.data.map(webinar => {
						return {
							...webinar,
							full_name: `${webinar.tutor.first_name} ${webinar.tutor.last_name}`,
						};
					});
					this.filteredWebinars = this.webinars;
				})
				.catch(err => this.formatErrors(err));
		},

		// Filter webinars
		async filterWebinars() {
			await this.getWebinars(this.search);
			if (this.search.tutorName) {
				this.filteredWebinars = this.filteredWebinars.filter(webinar =>
					webinar.full_name
						.toLowerCase()
						.includes(this.search.tutorName.toLowerCase())
				);
			}
			if (this.search.halaqaType) {
				this.filteredWebinars = this.filteredWebinars.filter(webinar =>
					webinar.webinar_type
						.toLowerCase()
						.includes(this.search.halaqaType.toLowerCase())
				);
			}
		},

		// Clear filters
		clearSearch() {
			this.search = {
				fromDate: moment(new Date()).format("Y-MM-DD"),
				toDate: moment(new Date())
					.add(1, "M")
					.format("Y-MM-DD"),
				tutorName: "",
				halaqaType: "",
			};
			this.getWebinars(this.search);
		},

		// Get language to use as webinar language
		async getWebinarLanguage() {
			let languages = [];

			await this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}tutor/detail/${this.addHalaqaForm.tutor}/`,
					{},
					this.headers
				)
				.then(res => {
					languages = res.data.data.tutor.languages;

					if (languages.includes("Arabic")) {
						this.webinarLanguage = 2;
						return;
					}
					if (languages.includes("English")) {
						this.webinarLanguage = 1;
						return;
					}
					if (languages.includes("French")) {
						this.webinarLanguage = 3;
						return;
					}
					if (languages.includes("Urdu")) {
						this.webinarLanguage = 4;
						return;
					}
				})
				.catch(err => this.formatErrors(err));
		},

		// Add new Halaqa
		async addHalaqa() {
			await this.getWebinarLanguage();

			const hours = Math.floor(this.addHalaqaForm.NumberOfMinutes / 60);
			const minutes = this.addHalaqaForm.NumberOfMinutes % 60;
			const body = {
				institute: this.currentIns,
				tutor: this.addHalaqaForm.tutor,
				start_date: this.addHalaqaForm.startDate,
				start_time: this.addHalaqaForm.startTime,
				webinar_type: this.addHalaqaForm.webinarType,
				webinar_language: this.webinarLanguage,
				title: this.addHalaqaForm.title,
				description: this.addHalaqaForm.description,
				duration_in_hours: hours,
				duration_in_minutes: minutes,
			};

			await this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}p2p/add-webinars/`,
					body,
					this.headers
				)
				.then(res => {
          this.setAlert('success', " ", "Halaqa has been added successfully" , 2000)

					this.cancelHalaqa();
				})
				.catch(err => {
					this.setAlert('error', this.$t("Oops"), err.response.data.detail, 3000)
					this.formatErrors();
				});

			await this.getWebinars(this.search);
		},

		// Cancel add new halaqa
		cancelHalaqa() {
			this.addHalaqaDialog = false;

			this.addHalaqaForm = {
				institute: this.currentIns,
				tutor: null,
				startTime: "",
				startDate: "",
				NumberOfMinutes: null,
				webinarType: "",
				title: "",
				description: "",
			};
		},
	},
	computed: {
		/**
		 * Check if user is super admin or not
		 */
		checkUser() {
			return this.userObj.auth.user.user.user_type === "operator";
		},

		/**
		 * Gets current chosen institute ID
		 */
		getInstituteId() {
			return this.userObj.auth.user.user.user_type === "operator"
				? 1
				: +this.userObj.auth.user.user.username.slice("").at(-1);
		},

		webinarHeadersTitles() {
			return [
				{
					text: this.$t("webinar_Type"),
					value: "webinar_type",
					sortable: false,
				},
				{
					text: this.$t("tutorName"),
					value: "full_name",
					sortable: false,
				},
				{ text: this.$t("webinarName"), value: "title", sortable: false },
				{
					text: this.$t("quiz.description"),
					value: "description",
					sortable: false,
				},
				{
					text: this.$t("tables.startDate"),
					value: "start_date",
					sortable: false,
				},
				{
					text: this.$t("tables.startTime"),
					value: "start_time",
					sortable: false,
				},
				// { text: this.$t("Action"), value: "actions", sortable: false },
			];
		},
	},
};
</script>

<style lang="scss" scoped>
.search {
	display: grid;
	grid-template-columns: 1fr;
	align-items: center;

	.search-inputs {
		display: grid;
		grid-template-columns: 1fr;
		margin-top: 1rem;
		align-items: center;
	}

	.search-btn-group {
		display: flex;
		justify-content: center;
		margin-bottom: 2rem;
	}
}

.actions-btn-group {
	display: flex;
	justify-content: center;
	gap: 2rem;
}

.action-btn {
	color: #fff;
}

@media (min-width: 767px) {
	.search {
		.search-inputs {
			grid-template-columns: 1fr 1fr 1fr 1fr;
			gap: 1rem;
		}

		.search-btn-group {
			margin-bottom: 0;
		}
	}
}
</style>
